import React, { useEffect, useState } from 'react';
import {
  // Typography,
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  InputAdornment,
  Box,
  Typography,
  Modal,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import PageHeader from '../../components/PageHeader';
import { Link, useNavigate, useParams } from 'react-router-dom';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PersonDetail from '../../components/PersonDetail';
import { api } from '../../api';
import { PersonInfo } from '../../schema/person';

const ControlOutDetail: React.FC = () => {
  const { person_id } = useParams();
  const navigate = useNavigate();
  const [exchangeData, setExchangeData] = useState<PersonInfo | null>(null);
  const [checkedPersonGPS, setCheckedPersonGPS] = useState<string>('');
  const [checkedVehicleGPS, setCheckedVehicleGPS] = useState<string>('');
  const [errorPersonGPS, setErrorPersonGPS] = useState<string>('');
  const [errorVehicleGPS, setErrorVehicleGPS] = useState<string>('');
  const [isShowMissingModal, setIsShowMissingModal] = useState<boolean>(false);
  const [errorMissingModal, setErrorMissingModal] = useState<string>('');
  const [isPersonGPSMissing, setIsPersonGPSMissing] = useState<boolean>(false);
  const [isVehicleGPSMissing, setIsVehicleGPSMissing] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const exchangeOut = ({
    is_person_gps_missing,
    is_vehicle_gps_missing
  }: {
    is_person_gps_missing: boolean;
    is_vehicle_gps_missing: boolean;
  }) => {
    if (isLoading) {
      return;
    }

    if (person_id) {
      setIsLoading(true);
      api
        .post(`/exchange-card/person/${person_id}/out`, {
          is_person_gps_missing: is_person_gps_missing,
          is_vehicle_gps_missing: is_vehicle_gps_missing
        })
        .then(() => {
          navigate('/control-in-out');
        })
        .finally(() => setIsLoading(false))
        .catch(function (error) {
          if (error.response) {
            console.log("error")
            setErrorMissingModal(JSON.stringify(error.response.data));
            setOpenConfirmDialog(true);
          }
        });
    }
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    let error = false;
    if (exchangeData?.person_gps_id && exchangeData?.person_gps_id != checkedPersonGPS) {
      setErrorPersonGPS('required');
      error = true;
    }
    if (exchangeData?.vehicle_gps_id && exchangeData?.vehicle_gps_id != checkedVehicleGPS) {
      setErrorVehicleGPS('required');
      error = true;
    }
    if (error) {
      return;
    }
    exchangeOut({
      is_person_gps_missing: false,
      is_vehicle_gps_missing: false
    });
  };

  const handleModalSubmit = () => {
    if (!isPersonGPSMissing && !isVehicleGPSMissing) {
      setErrorMissingModal('กรุณาเลือกประเภทบัตรที่หาย');
      return;
    }
    let error = false;
    if (
      !isPersonGPSMissing &&
      exchangeData?.person_gps_id &&
      exchangeData?.person_gps_id != checkedPersonGPS
    ) {
      setErrorMissingModal('ต้องการเลขอุปกรณ์ติดตามประจำตัว');
      error = true;
    }
    if (
      !isVehicleGPSMissing &&
      exchangeData?.vehicle_gps_id &&
      exchangeData?.vehicle_gps_id != checkedVehicleGPS
    ) {
      setErrorMissingModal('ต้องการเลขอุปกรณ์ติดตามยานพาหนะ');
      error = true;
    }
    if (error) {
      return;
    }
    exchangeOut({
      is_person_gps_missing: isPersonGPSMissing,
      is_vehicle_gps_missing: isVehicleGPSMissing
    });
  };

  const handleCloseMissingModal = () => {
    // setIsCardMissing(false);
    setIsPersonGPSMissing(false);
    setIsVehicleGPSMissing(false);
    setIsShowMissingModal(false);
  };
  useEffect(() => {
    if (person_id) {
      api.get(`/exchange-card/person/${person_id}`).then((res) => {
        const { data } = res;
        if (!data?.exchange_card_id) {
          navigate(`/control-in-out/in/${person_id}`);
        }
        setExchangeData(data);
      })
    }
  }, [person_id]);

  useEffect(() => {
    if (checkedPersonGPS != '') {
      if (exchangeData?.person_gps_id == checkedPersonGPS) {
        setErrorPersonGPS('');
        return;
      }
      setErrorPersonGPS('error');
    }
  }, [checkedPersonGPS, exchangeData]);
  useEffect(() => {
    if (checkedVehicleGPS != '') {
      if (exchangeData?.vehicle_gps_id == checkedVehicleGPS) {
        setErrorVehicleGPS('');
        return;
      }
      setErrorVehicleGPS('error');
    }
  }, [checkedVehicleGPS, exchangeData]);

  return (
    <Container>
      <PageHeader text="การควบคุมบุคคลออก" />

      <Button component={Link} to="/control-in-out" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        การควบคุมบุคคลเข้า-ออก
      </Button>

      {/* <Typography variant="body2" sx={{ paddingY: 3 }}>
        เพิ่มข้อมูลการขอแลกบัตรล่วงเวลา
      </Typography> */}
      <PersonDetail person_id={person_id} />

      <Paper sx={{ p: 1, mt: 3 }}>
        <Typography variant="h6" sx={{ p: 2 }}>
          ข้อมูลแลกบัตรออก
        </Typography>
        <Form onSubmit={handleFormSubmit} sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="หมายเลขบัตร"
                variant="outlined"
                placeholder="หมายเลขบัตร"
                value={exchangeData?.exchange_card_id ? exchangeData.exchange_card_id : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.exchange_card_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ประเภทบัตรที่แลก"
                variant="outlined"
                placeholder="ประเภทบัตรที่แลก"
                value={
                  exchangeData?.exchange_card_type?.type_name
                    ? exchangeData?.exchange_card_type?.type_name
                    : ''
                }
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.exchange_card_type?.type_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เลขอุปกรณ์ติดตามประจำตัว"
                variant="outlined"
                placeholder={
                  exchangeData?.person_gps_id
                    ? exchangeData.person_gps_id
                    : 'เลขอุปกรณ์ติดตามประจำตัว'
                }
                InputProps={
                  exchangeData?.person_gps_id
                    ? {
                        startAdornment: (
                          <InputAdornment position="start">
                            <QrCode2Icon />
                          </InputAdornment>
                        )
                      }
                    : undefined
                }
                value={checkedPersonGPS}
                onChange={(e) => {
                  const gps_id = String(e.target.value).split(":")
                  setCheckedPersonGPS(gps_id.length >= 7 ? gps_id[3] : e.target.value)
                }}
                disabled={!exchangeData?.person_gps_id}
                error={!!errorPersonGPS}
                helperText={errorPersonGPS}
                // onInput={(newInputValue) => {
                //   const gps_id = String(newInputValue).split(':');
                //   setCheckedPersonGPS(gps_id[3])
                // }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เลขอุปกรณ์ติดตามยานพาหนะ"
                variant="outlined"
                placeholder={
                  exchangeData?.vehicle_gps_id
                    ? exchangeData.vehicle_gps_id
                    : 'เลขอุปกรณ์ติดตามยานพาหนะ'
                }
                InputProps={
                  exchangeData?.vehicle_gps_id
                    ? {
                        startAdornment: (
                          <InputAdornment position="start">
                            <QrCode2Icon />
                          </InputAdornment>
                        )
                      }
                    : undefined
                }
                value={checkedVehicleGPS}
                onChange={(e) => setCheckedVehicleGPS(e.target.value)}
                disabled={!exchangeData?.vehicle_gps_id}
                error={!!errorVehicleGPS}
                helperText={errorVehicleGPS}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="หมายเลขทะเบียนยานพาหนะ"
                variant="outlined"
                placeholder="หมายเลขทะเบียนยานพาหนะ"
                value={
                  exchangeData?.vehicle_plate_name ? exchangeData.vehicle_plate_name : ''
                }
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.vehicle_plate_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="วัตถุประสงค์"
                variant="outlined"
                placeholder="วัตถุประสงค์"
                value={exchangeData?.reason ? exchangeData.reason : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.reason}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="remark"
                variant="outlined"
                placeholder="remark"
                multiline
                minRows={4}
                value={exchangeData?.remark ? exchangeData.remark : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.remark}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: 0 }} direction={'row-reverse'}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" disabled={isLoading}>
                {isLoading ? (
                  <CircularProgress color="primary" size={'1.25rem'} sx={{ mr: 2 }} />
                ) : null}
                {`แลกบัตรออก`}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="warning"
                onClick={() => setIsShowMissingModal(true)}
              >
                แจ้งอุปกรณ์หาย
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Modal
        open={isShowMissingModal}
        onClose={() => handleCloseMissingModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer
          sx={{
            width: '400px'
          }}
        >
          <Box mt={3}>
            <Typography variant="h5" mb={2}>
              แจ้งหายประเภทอุปกรณ์
            </Typography>
            <FormGroup>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={isCardMissing}
                    onChange={(_, value) => setIsCardMissing(value)}
                  />
                }
                label="บัตรเข้าออก"
              /> */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPersonGPSMissing}
                    onChange={(_, value) => setIsPersonGPSMissing(value)}
                  />
                }
                label="อุปกรณ์ติดตามประจำตัว"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isVehicleGPSMissing}
                    onChange={(_, value) => setIsVehicleGPSMissing(value)}
                  />
                }
                label="อุปกรณ์ติดตามยานพาหนะ"
              />
            </FormGroup>
          </Box>
          {errorMissingModal ? (
            <Typography color={'error'} sx={{ mb: 0 }}>
              *{errorMissingModal}
            </Typography>
          ) : null}
          <Grid container spacing={2} sx={{ my: 3 }} justifyContent="center">
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => handleModalSubmit()}
              >
                ยืนยันและแลกบัตรออก
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                fullWidth
                onClick={() => handleCloseMissingModal()}
              >
                ยกเลิก
              </Button>
            </Grid>
          </Grid>
        </ModalContainer>
      </Modal>
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
          เกิดข้อผิดพลาด
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMissingModal}
            <br/><br/>{errorMissingModal != '' ? "กรุณาบันทึกภาพหน้าจอนี้ประสานงานไปยังเจ้าหน้าที่" : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 2 }}>
        <Button
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
              color="primary"
              autoFocus
            >
              ยืนยัน
            </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ControlOutDetail;

const Container = styled('div')`
  padding: 16px;
  margin-bottom: 32px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  borderRadius: 16,
  padding: 16,
  width: '70%'
}));
